import getB4AList from "./getB4AList";
import createB4A from "./createB4A";
import getB4A from "./getB4A";
import changeStatus from "./changeStatus";
import updateB4A from "./updateB4A";
import deleteB4A from "./deleteB4A";

export default {
  getB4AList,
  createB4A,
  getB4A,
  changeStatus,
  updateB4A,
  deleteB4A,
};
